import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';
import { FieldPath, FieldValues, PathValue } from 'react-hook-form';
import RHFRadio from '@/components/hook-form/RHFRadio';

const StyledCardRadioContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '& .MuiRadioGroup-root': {
    gap: 0,
  },
  '& .MuiFormControlLabel-root': {
    margin: 0,
    width: '100%',
    padding: '8px 16px',
    marginBottom: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[500_24]}`,
    borderRadius: '8px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.grey[500_24],
    },
    '&:focus-within': {
      borderColor: theme.palette.grey[500],
    },
    '&:has(.Mui-checked)': {
      backgroundColor: theme.palette.grey[500_12],
    },
    '& .MuiFormControlLabel-label': {
      flex: 1,
    },
  },
  '& .MuiRadio-root': {
    accentColor: theme.palette.primary.main,
  },
}));

type Props<TFieldValues extends FieldValues = FieldValues> = {
  name: FieldPath<TFieldValues>;
  options: { value: PathValue<TFieldValues, FieldPath<TFieldValues>>; label: ReactNode }[];
  isDisabled?: boolean;
  onValueChange?: (value: PathValue<TFieldValues, FieldPath<TFieldValues>>) => void;
};

export default function RHFCardRadio<TFieldValues extends FieldValues = FieldValues>({
  name,
  options,
  isDisabled,
  onValueChange,
}: Props<TFieldValues>) {
  return (
    <StyledCardRadioContainer>
      <RHFRadio name={name} options={options} isDisabled={isDisabled} onValueChange={onValueChange} />
    </StyledCardRadioContainer>
  );
}
